var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        LOGIN: 'api/posv3/user/EmployeeLogin',
        LOGOUT: 'api/posv3/user/Logout',
        FORGOT: 'api/posv3/user/ForgotPassword',
        RESET: 'api/posv3/user/ResetPassword',

        GET_DPH_USER: 'api/dph/get-user',
        SET_DPH_USER: 'api/dph/update-user',
        ENABLE_MANAGER_OVERRIDE: 'api/dph/enable-manager-override',
        DISABLE_MANAGER_OVERRIDE: 'api/dph/disable-manager-override',

        SSO_LOGIN: 'api/SAML/SSOLoginRedirect',
        PASSWORD_SETTINGS: 'api/security/password/settings',
    },

    actions: keyMirror({
        LOGIN: null,
        LOGOUT: null,

        SSO_LOGIN: null,
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
    }),
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/AuthConstants.jsx